/* global updateCartTieredIncentiveProgress */
(function freeGift() {
  if (window.__freeGiftLoaded) return;
  window.__freeGiftLoaded = true;

  const config = window.freeGiftConfig || {};
  const GIFT_VARIANT_ID = Number(config.variantId);
  const THRESHOLD_CENTS = Number(config.thresholdCents) || 15000;
  const GIFT_PROPERTY = config.propertyKey || '_labor_day_gift';
  const START = config.startDate ? new Date(config.startDate) : null;
  const END = config.endDate ? new Date(config.endDate) : null;

  if (!Number.isFinite(GIFT_VARIANT_ID) || GIFT_VARIANT_ID <= 0) return;
  if (config.isWholesale === true) return;

  const POLL_MS = 1500;

  let running = false;
  let lastFingerprint = null;

  const isActive = () => {
    const now = new Date();
    if (START && Number.isFinite(START.getTime()) && now < START) return false;
    if (END && Number.isFinite(END.getTime()) && now > END) return false;
    return true;
  };

  const isGiftLine = (item) => Number(item.variant_id) === GIFT_VARIANT_ID;

  // Changes whenever any line or quantity changes.
  const fingerprint = (cart) => `${cart.item_count}|${cart.total_price}|` +
    cart.items.map((i) => `${i.variant_id}:${i.quantity}`).join(',');

  const eligibleSubtotal = (cart) => cart.items.reduce(
    (sum, item) => (isGiftLine(item) ? sum : sum + item.final_line_price),
    0
  );

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!res.ok) throw new Error(`Cart request failed: ${res.status}`);
    return res.json();
  }

  async function postJson(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(`${url} failed: ${res.status} ${await res.text()}`);
    return res.json();
  }

  const addGift = () => postJson('/cart/add.js', {
    items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { [GIFT_PROPERTY]: 'true' } }]
  });

  const setQty = (key, quantity) => postJson('/cart/change.js', { id: key, quantity });

  /**
   * Brings the cart to the correct gift state. Always works from a freshly
   * fetched cart, and re-verifies after any write.
   */
  async function reconcile() {
    if (running) {
      // A pass is already in flight. Mark the state dirty so the next poll
      // re-checks rather than assuming this change was handled.
      lastFingerprint = null;
      return;
    }
    running = true;

    try {
      let cart = await getCart();
      let changed = false;

      const wrap = document.querySelector('[data-cart-incentives]');
      if (wrap) wrap.dataset.giftPromoActive = isActive() ? 'true' : 'false';

      const qualifies = isActive()
        && cart.items.some((i) => !isGiftLine(i))
        && eligibleSubtotal(cart) >= THRESHOLD_CENTS;

      if (qualifies && !cart.items.some(isGiftLine)) {
        await addGift();
        changed = true;
        cart = await getCart();
      }

      // Enforce exactly one gift line at qty 1, or none if unqualified.
      const lines = cart.items.filter(isGiftLine);
      if (!qualifies) {
        for (const line of lines) {
          await setQty(line.key, 0);
          changed = true;
        }
      } else {
        for (let i = 1; i < lines.length; i += 1) {
          await setQty(lines[i].key, 0);
          changed = true;
        }
        if (lines.length && lines[0].quantity !== 1) {
          await setQty(lines[0].key, 1);
          changed = true;
        }
      }

      if (changed) {
        const finalCart = await getCart();
        lastFingerprint = fingerprint(finalCart);
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        if (typeof updateCartTieredIncentiveProgress === 'function') {
          setTimeout(() => updateCartTieredIncentiveProgress(), 150);
        }
      } else {
        lastFingerprint = fingerprint(cart);
      }
    } catch (err) {
      console.error('Free gift error:', err);
    } finally {
      running = false;
    }
  }

  /**
   * Cheap poll: only reconciles when the cart actually changed.
   */
  async function poll() {
    if (running || document.hidden) return;
    try {
      const cart = await getCart();
      const fp = fingerprint(cart);
      if (fp !== lastFingerprint) {
        // Do NOT record the fingerprint here. reconcile() sets it only after
        // it has actually finished, so a skipped or failed pass gets retried
        // on the next tick instead of being marked as handled.
        await reconcile();
      }
    } catch (err) {
      // Network hiccup; try again next tick.
    }
  }

  window.setInterval(poll, POLL_MS);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) poll(); });
  window.addEventListener('pageshow', () => reconcile());

  reconcile();

  window.syncFreeGift = reconcile;
}());